// @flow
import * as Immutable from 'immutable'; // This is required
import ImmutableModel from './ImmutableModel';
import { Amount } from './Amount';
import { PackageInfo } from './PackageInfo';
import { TransactionStatus } from './TransactionStatus';
import { LineItemSummary } from './LineItemSummary';

import type { AmountModelType } from './Amount';
import type { PackageInfoModelType } from './PackageInfo';
import type { TransactionStatusModelType } from './TransactionStatus';
import type { LineItemSummaryModelType } from './LineItemSummary';

export type LineItemModelType = {
    name: string,
    quantity: number,
    id: string,
    imageUrl: string,
    price: AmountModelType,
    version: number,
    packageInfo: ?PackageInfoModelType,
    transactionStatus: ?TransactionStatusModelType,
    summary: LineItemSummaryModelType,
    scanId: ?string
};

// /////////////////////////////////////////////////////////////////////////////
//
// NOTE: THIS CLASS IS GENERATED. DO NOT MAKE CHANGES HERE.
//
// If you need to update this class, update the corresponding flow type above
// and re-run the flow-immutable-models codemod
//
// /////////////////////////////////////////////////////////////////////////////
export class LineItem extends ImmutableModel {
    static fromJS(json: LineItemModelType): LineItem {
        const state: Object = Object.assign({}, json);
        state.price = Amount.fromJS(state.price);
        state.packageInfo = state.packageInfo
            ? PackageInfo.fromJS(state.packageInfo)
            : state.packageInfo;
        state.transactionStatus = state.transactionStatus
            ? TransactionStatus.fromJS(state.transactionStatus)
            : state.transactionStatus;
        state.summary = LineItemSummary.fromJS(state.summary);
        return new this(Immutable.Map(state));
    }

    toJS(): LineItemModelType {
        return {
            name: this.name,
            quantity: this.quantity,
            id: this.id,
            imageUrl: this.imageUrl,
            price: this.price.toJS(),
            version: this.version,
            packageInfo: this.packageInfo
                ? this.packageInfo.toJS()
                : this.packageInfo,
            transactionStatus: this.transactionStatus
                ? this.transactionStatus.toJS()
                : this.transactionStatus,
            summary: this.summary.toJS(),
            scanId: this.scanId
        };
    }

    get name(): string {
        return this._state.get('name');
    }

    setName(name: string): this {
        return this.clone(this._state.set('name', name));
    }

    get quantity(): number {
        return this._state.get('quantity');
    }

    setQuantity(quantity: number): this {
        return this.clone(this._state.set('quantity', quantity));
    }

    get id(): string {
        return this._state.get('id');
    }

    setId(id: string): this {
        return this.clone(this._state.set('id', id));
    }

    get imageUrl(): string {
        return this._state.get('imageUrl');
    }

    setImageUrl(imageUrl: string): this {
        return this.clone(this._state.set('imageUrl', imageUrl));
    }

    get price(): Amount {
        return this._state.get('price');
    }

    setPrice(price: Amount): this {
        return this.clone(this._state.set('price', price));
    }

    get version(): number {
        return this._state.get('version');
    }

    setVersion(version: number): this {
        return this.clone(this._state.set('version', version));
    }

    get packageInfo(): ?PackageInfo {
        return this._state.get('packageInfo');
    }

    setPackageInfo(packageInfo: ?PackageInfo): this {
        return this.clone(this._state.set('packageInfo', packageInfo));
    }

    get transactionStatus(): ?TransactionStatus {
        return this._state.get('transactionStatus');
    }

    setTransactionStatus(transactionStatus: ?TransactionStatus): this {
        return this.clone(
            this._state.set('transactionStatus', transactionStatus)
        );
    }

    get summary(): LineItemSummary {
        return this._state.get('summary');
    }

    setSummary(summary: LineItemSummary): this {
        return this.clone(this._state.set('summary', summary));
    }

    get scanId(): ?string {
        return this._state.get('scanId');
    }

    setScanId(scanId: ?string): this {
        return this.clone(this._state.set('scanId', scanId));
    }
}
